import api from './axiosConfig';

// Servicios de tags
export const tagService = {
  // Obtener todos los tags
  getAllTags: async () => {
    try {
      const response = await api.get('/tags');
      return response.data;
    } catch (error) {
      throw error.response?.data || { message: 'Error en el servidor' };
    }
  },

  // Obtener solo tags activos
  getActiveTags: async () => {
    try {
      const response = await api.get('/tags/active');
      return response.data;
    } catch (error) {
      throw error.response?.data || { message: 'Error en el servidor' };
    }
  },

  // Obtener solo tags inactivos
  getInactiveTags: async () => {
    try {
      const response = await api.get('/tags/inactive');
      return response.data;
    } catch (error) {
      throw error.response?.data || { message: 'Error en el servidor' };
    }
  },

  // Obtener tag por ID
  getTagById: async (id) => {
    try {
      const response = await api.get(`/tags/${id}`);
      return response.data;
    } catch (error) {
      throw error.response?.data || { message: 'Error en el servidor' };
    }
  },

  // Buscar tags por criterios (todos los campos son opcionales)
  searchTags: async (searchParams) => {
    try {
      const queryString = new URLSearchParams(searchParams).toString();
      const response = await api.get(`/tags/search?${queryString}`);
      return response.data;
    } catch (error) {
      throw error.response?.data || { message: 'Error en el servidor' };
    }
  },

  // Crear nuevo tag (todos los campos son opcionales)
  createTag: async (tagData) => {
    try {
      // Enviar solo los campos que tengan valor
      const filteredData = Object.fromEntries(
        Object.entries(tagData).filter(([_, value]) => value !== '' && value !== null && value !== undefined)
      );
      
      const response = await api.post('/tags', filteredData);
      return response.data;
    } catch (error) {
      throw error.response?.data || { message: 'Error en el servidor' };
    }
  },

  // Actualizar tag (todos los campos son opcionales)
  updateTag: async (id, tagData) => {
    try {
      // Enviar solo los campos que tengan valor
      const filteredData = Object.fromEntries(
        Object.entries(tagData).filter(([_, value]) => value !== '' && value !== null && value !== undefined)
      );
      
      const response = await api.put(`/tags/${id}`, filteredData);
      return response.data;
    } catch (error) {
      throw error.response?.data || { message: 'Error en el servidor' };
    }
  },

  // Activar un tag
  activateTag: async (id) => {
    try {
      const response = await api.put(`/tags/${id}/activate`);
      return response.data;
    } catch (error) {
      throw error.response?.data || { message: 'Error en el servidor' };
    }
  },

  // Desactivar un tag
  deactivateTag: async (id) => {
    try {
      const response = await api.put(`/tags/${id}/deactivate`);
      return response.data;
    } catch (error) {
      throw error.response?.data || { message: 'Error en el servidor' };
    }
  },

  // Cambiar estado de múltiples tags
  toggleMultipleTagsStatus: async (ids, activo) => {
    try {
      const response = await api.put('/tags/status', { ids, activo });
      return response.data;
    } catch (error) {
      throw error.response?.data || { message: 'Error en el servidor' };
    }
  },

  // Eliminar tag
  deleteTag: async (id) => {
    try {
      const response = await api.delete(`/tags/${id}`);
      return response.data;
    } catch (error) {
      throw error.response?.data || { message: 'Error en el servidor' };
    }
  },

  // Eliminar múltiples tags
  deleteMultipleTags: async (ids) => {
    try {
      const response = await api.delete('/tags', { data: { ids } });
      return response.data;
    } catch (error) {
      throw error.response?.data || { message: 'Error en el servidor' };
    }
  }
};

export default tagService;
